export const Types = {
    GET_BREAKDOWN_REASON_DETAILS: "GET_BREAKDOWN_REASON_DETAILS",
    SET_BREAKDOWN_REASON_DETAILS: "SET_BREAKDOWN_REASON_DETAILS",
    ADD_BREAKDOWN_REASON_DETAIL: "ADD_BREAKDOWN_REASON_DETAIL",
    UPDATE_BREAKDOWN_REASON_DETAIL: "UPDATE_BREAKDOWN_REASON_DETAIL",
    DELETE_BREAKDOWN_REASON_DETAIL: "DELETE_BREAKDOWN_REASON_DETAIL",
    GET_PLANTS: "GET_PLANTS",
    SET_PLANTS: "SET_PLANTS",
    GET_BREAKDOWN_REASON_GROUPS: "GET_BREAKDOWN_REASON_GROUPS",
    SET_BREAKDOWN_REASON_GROUPS: "SET_BREAKDOWN_REASON_GROUPS",
    GET_BREAKDOWN_REASON_PLACE_BY_ID: "GET_BREAKDOWN_REASON_PLACE_BY_ID",
    SET_BREAKDOWN_REASON_PLACE_BY_ID: "SET_BREAKDOWN_REASON_PLACE_BY_ID",

    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
};

export const getBreakdownReasonDetails = () => {
    return {
        type: Types.GET_BREAKDOWN_REASON_DETAILS,
    };
};

export const setBreakdownReasonDetails = (payload) => {
    return {
        type: Types.SET_BREAKDOWN_REASON_DETAILS,
        payload: payload,
    };
};

export const addBreakdownReasonDetail = (payload) => {
    return {
        type: Types.ADD_BREAKDOWN_REASON_DETAIL,
        payload: payload,
    };
};

export const updateBreakdownReasonDetail = (payload) => {
    return {
        type: Types.UPDATE_BREAKDOWN_REASON_DETAIL,
        payload: payload,
    };
};

export const deleteBreakdownReasonDetail = (payload) => {
    return {
        type: Types.DELETE_BREAKDOWN_REASON_DETAIL,
        payload: payload,
    };
};

export const getPlants = () => ({
    type: Types.GET_PLANTS,
});

export const setPlants = (payload) => ({
    type: Types.SET_PLANTS,
    payload: payload,
});

export const getBreakDownReasonGroups = () => ({
    type: Types.GET_BREAKDOWN_REASON_GROUPS,
});

export const setBreakDownReasonGroups = (payload) => ({
    type: Types.SET_BREAKDOWN_REASON_GROUPS,
    payload: payload,
});

export const getBreakdownReasonPlaceByGroupId = (payload) => ({
    type: Types.GET_BREAKDOWN_REASON_PLACE_BY_ID,
    payload: payload,
});

export const setBreakdownReasonPlaceByGroupId = (payload) => ({
    type: Types.SET_BREAKDOWN_REASON_PLACE_BY_ID,
    payload: payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});
